import { GROUPS, PREFIX } from '@/service/apiConf';
import { get } from '@/service/request';

export interface SharedVolumePvcListResponse {
  items?: unknown[];
  totalItems?: number;
}

/** 拉取可用共享 PVC 列表 */
export function getSharedVolumePersistentVolumeClaims(params?: Record<string, unknown>): Promise<SharedVolumePvcListResponse> {
  return get(`${PREFIX.vapis_v1_dc_ws(GROUPS.persistentvolumeclaim)}/all-persistentvolumeclaims`, {
    limit: -1,
    type: 'shared',
    ...params,
  });
}
